__turbopack_context__.v({
  "smart-adv-lira": "index-module-scss-module__hYULNq__smart-adv-lira",
  "smart-adv-lira-wrapper": "index-module-scss-module__hYULNq__smart-adv-lira-wrapper",
});
